import { useEffect, useState, useRef } from "react";
import { PageSection } from "../layout/PageSection";
import { RelativePerformance } from "../chartlayouts/relativeperformance/RelativePerformance";
import { Horizon } from "../chartlayouts/horizon/Horizon";
import { VectorSet2 } from "../chartlayouts/vectorset2/VectorSet2";
import { FairValue } from "../chartlayouts/fairvalue/FairValue";
import { VSFP } from "../chartlayouts/vsfp/VSFP";
import { OaRVaR } from "../chartlayouts/oarvar/OaRVaR";
import { StoredValue } from "../chartlayouts/storedvalue/StoredValue";
import { BreakageAndReturn } from "../chartlayouts/breakageandreturn/BreakageAndReturn";

const CHART_SECTIONS = [
  { key: "relativeperformance", Component: RelativePerformance },
  { key: "horizon", Component: Horizon },
  { key: "vectorset2", Component: VectorSet2 },
  { key: "fairvalue", Component: FairValue },
  { key: "oarvar", Component: OaRVaR },
  { key: "storedvalue", Component: StoredValue },
  { key: "vsfp", Component: VSFP },
  { key: "breakageandreturn", Component: BreakageAndReturn },
];

const FRAMES_BETWEEN_LOADS = 4;

export const Home = () => {
  const [loadedCount, setLoadedCount] = useState(1); // Start with first section
  const frameCountRef = useRef(0);
  const rafIdRef = useRef(null);

  useEffect(() => {
    if (loadedCount >= CHART_SECTIONS.length) return;

    frameCountRef.current = 0;

    const tick = () => {
      frameCountRef.current++;
      
      if (frameCountRef.current >= FRAMES_BETWEEN_LOADS) {
        setLoadedCount((prev) => prev + 1);
      } else {
        rafIdRef.current = requestAnimationFrame(tick);
      }
    };

    rafIdRef.current = requestAnimationFrame(tick);

    return () => {
      if (rafIdRef.current) {
        cancelAnimationFrame(rafIdRef.current);
      }
    };
  }, [loadedCount]);

  return (
    <PageSection>
      {CHART_SECTIONS.slice(0, loadedCount).map(({ key, Component }) => (
        <Component key={key} />
      ))}
    </PageSection>
  );
};
